// keys must stay in sync with AgreementVariables in
// backend/app/utils/rentals_pdf/agreement_template.utils.go (unknown keys are rejected with 422)
export type AgreementVariable = {
  key: string;
  label: string;
  sample: string;
};

export const AGREEMENT_VARIABLES: AgreementVariable[] = [
  { key: 'customerCompanyName', label: 'Customer Company', sample: 'Acme Freight LLC' },
  { key: 'customerFullName', label: 'Customer Name', sample: 'John Doe' },
  { key: 'customerAddress', label: 'Customer Address', sample: '100 Main St, Dallas, TX, 75201' },
  { key: 'customerPhone', label: 'Customer Phone', sample: '(555) 123-4567' },
  { key: 'customerEmail', label: 'Customer Email', sample: 'john.doe@acmefreight.com' },
  { key: 'customerDotNumber', label: 'Customer DOT Number', sample: '1234567' },
  { key: 'customerMcNumber', label: 'Customer MC Number', sample: 'MC-987654' },
  { key: 'customerFeinNumber', label: 'Customer FEIN Number', sample: '12-3456789' },
  { key: 'trailerUnitNumber', label: 'Trailer Unit Number', sample: 'TR-1042' },
  { key: 'trailerMake', label: 'Trailer Make', sample: 'Great Dane' },
  { key: 'trailerModel', label: 'Trailer Model', sample: 'Everest' },
  { key: 'trailerYear', label: 'Trailer Year', sample: '2022' },
  { key: 'trailerVin', label: 'Trailer VIN', sample: '1GRAA0628NB123456' },
  { key: 'trailerLicensePlate', label: 'License Plate', sample: 'TX ABC-1234' },
  { key: 'eventDate', label: 'Rental Date', sample: '01/15/2026' },
  { key: 'eventDateTime', label: 'Rental Date & Time', sample: '01/15/2026 14:30 CST' },
  { key: 'rentalStartDate', label: 'Rental Start Date', sample: '01/15/2026' },
  { key: 'rentalEndDate', label: 'Rental End Date', sample: '02/15/2026' },
  { key: 'companyName', label: 'Company Name', sample: 'Your Company' },
  { key: 'ownerName', label: 'Owner Name', sample: 'Jane Doe' },
  { key: 'companyAddress', label: 'Company Address', sample: '200 Depot Rd, Chicago, IL, 60601' },
  { key: 'contactPhone', label: 'Company Phone', sample: '(555) 987-6543' },
  { key: 'contactEmail', label: 'Company Email', sample: 'office@yourcompany.com' },
  { key: 'companySignature', label: 'Owner Signature', sample: '' },
  { key: 'customerSignature', label: 'Customer Signature', sample: '' },
];

export const AGREEMENT_VARIABLE_LABELS: Record<string, string> = Object.fromEntries(
  AGREEMENT_VARIABLES.map((variable) => [variable.key, variable.label])
);
